/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator(), model);
        AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator.newInstance(<AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Exploitability metric(s) attack complexity v3.1 to include
     */
    attack_complexity_v31: Array<models.CvssV31ExploitabilityAttackComplexity>;

}
